import React from "react";
import { useLocation } from "react-router-dom";
import reduceChildRoutes from "./reduceChildRoutes";
import { SidebarItemsType } from "../../types/sidebar";

interface SidebarNavListProps {
  depth: number;
  pages: SidebarItemsType[];
}

const SidebarNavList = (props: SidebarNavListProps) => {
  const { pages, depth } = props;
  const router = useLocation();
  const currentRoute = router.pathname;

  const [activeHref, setActiveHref] = React.useState<string | null>(null);

  // Handle the toggle of active links
  const handleToggle = (href: string) => {
    setActiveHref((prev) => (prev === href ? null : href)); // toggle between active and inactive
  };

  // Pass `handleToggle` to `reduceChildRoutes` function
  const childRoutes = pages.reduce(
    (items, page) =>
      reduceChildRoutes({
        items,
        page,
        currentRoute,
        depth,
        onToggle: handleToggle,
        activeHref, // Pass activeHref to ensure proper rendering of opened/closed states
      }),
    [] as JSX.Element[]
  );

  return <>{childRoutes}</>;
};

export default SidebarNavList;
